<template>
  <div>
    <b-form-group
      v-if="showType == 'form-builder'"
      :description="properties.description"
      :label="properties.label"
      :style="properties.style"
    >
      <b-form-input
        :placeholder="properties.placeholder"
        type="password"
      ></b-form-input>
    </b-form-group>
    <div v-if="showType == 'properties'">
      <password-input-v1-properties :formId="formId" />
    </div>
    <b-form-group
      style="font-size: 14px"
      v-if="
        (showType == 'form-submitter' && page == currentPage) ||
          (showType == 'e-form' && properties.eFormEditable)
      "
      :description="
        computedConditions.description
          ? computedPropertiesForm.description
          : properties.description
      "
      :label="
        computedConditions.label
          ? computedPropertiesForm.label
          : properties.label
      "
      :style="properties.style"
      :hidden="computedHidden"
      :state="state"
      :invalid-feedback="errors.join(', ')"
    >
      <b-form-input
        style="font-size: 14px"
        type="password"
        :placeholder="
          computedConditions.placeholder
            ? computedPropertiesForm.placeholder
            : properties.placeholder
        "
        :readonly="
          computedConditions.readonly
            ? computedPropertiesForm.readonly
            : properties.readonly
        "
        :required="
          computedConditions.required
            ? computedPropertiesForm.required
            : properties.required
        "
        v-model="localValue"
        @blur="controlValue = localValue"
        :state="state"
      ></b-form-input>
    </b-form-group>
    <b-form-group
      v-if="
        showType == 'form-viewer' ||
          (showType == 'e-form' && !properties.eFormEditable)
      "
      :label="
        computedConditions.label
          ? computedPropertiesForm.label
          : properties.label
      "
    >
      {{ controlValue ? "*****" : "" }}
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import PasswordInputV1Properties from "./PasswordInputV1Properties.vue";
export default {
  name: "PasswordInputV1",
  components: { PasswordInputV1Properties },
  props: ["showType", "properties", "form", "id", "results", "formId", "page", "componentsIdSuffix"],
  data() {
    return {
      computedProperties: [
        "description",
        "label",
        "hidden",
        "placeholder",
        "readonly",
        "required"
      ],
      computedConditions: {},
      localValue: ""
    };
  },
  mounted() {
    this.localValue = this.controlValue;

    if(this.componentsIdSuffix) {
      this.initializeComponentValue({
        controlId: this.id,
        properties: this.properties
      });
    }
    this.computeConditions();
  },
  methods: {
    ...mapActions("formSubmitter", ["setFormSubmitterComponentValue", "computeFormSubmitterValue", "initializeComponentValue"]),
    computeConditions() {
      const computedConditions = {};
      for (let index = 0; index < this.computedProperties.length; index++) {
        const property = this.computedProperties[index];
        computedConditions[property] =
          typeof this.properties[property] == "string" &&
          this.properties[property].includes("{{");
      }
      this.computedConditions = computedConditions;
    },
    getComponentComputedProperties(property) {
      return this.computedPropertiesForm
        ? this.computedPropertiesForm[property] != null
          ? this.computedPropertiesForm[property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    getBakedLayout() {
      const hidden = this.getComponentComputedProperties(
        "hidden"
      );

      if(hidden === true)
        return "";
        
      return `
      <fieldset aria-describedby="" class="form-group">
        <legend style="font-size: 14px" tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">${this.getComponentComputedProperties(
          "label"
        )}</legend>
        <div style="font-size: 14px" tabindex="-1" role="group" class="bv-no-focus-ring">
          ${this.controlValue ? "*****" : ""}
        </div>
      </fieldset>`;
    }
  },
  computed: {
    ...mapState("formSubmitter", {
      formErrors: state => state.form.errors,
      currentPage: state => state.form.currentPage
    }),
    ...mapGetters("formSubmitter", [
      "getFormSubmitterComponentValue"
    ]),
    computedPropertiesForm() {
      return this.$store.state.formSubmitter.form.computedProperties[this.id] ?? this.properties;
    },
    controlValue: {
      get() {
        if (this.results) return this.results[this.id];
        return this.getFormSubmitterComponentValue(this.id);
      },
      set(newControlValue) {
        if (this.controlValue != newControlValue) {
          this.setFormSubmitterComponentValue({
            controlId: this.id,
            controlValue: newControlValue,
            userAction: true
          });
          this.$emit("update-child-control-value", {
            controlId: this.id,
            controlValue: newControlValue
          });
          if (this.properties.onChange) {
            this.computeFormSubmitterValue({
              elementId: this.id,
              property: "onChange",
              value: `computed:(${this.properties.onChange})(${JSON.stringify(
                newControlValue
              )})`,
              defaultValue: null,
              form: this.form,
              statements: true
            });
          }
        }
      }
    },
    errors: {
      get() {
        return this.formErrors[this.id] ? this.formErrors[this.id] : [];
      }
    },
    state: {
      get() {
        return this.errors.length == 0 ? null : false;
      }
    },
    computedHidden() {
      const hiddenValue = this.computedConditions.hidden
        ? this.computedPropertiesForm.hidden
        : this.properties.hidden

      this.$emit("change-hidden-property", hiddenValue);
      return hiddenValue;
    }
  },
  watch: {
    controlValue(newValue) {
      if (newValue != this.localValue) {
        this.localValue = newValue;
      }
    }
  }
};
</script>
